/**
 * Created by anatoly on 01.04.2026
 */

const StickersRewardAction = function (f) {
    if (cleverapps.stickersBook && cleverapps.stickersBook.newStickers) {
        new StickersRewardWindow();
        cleverapps.focusManager.onceNoWindowsListener = f;
    } else {
        f();
    }
};
